import React, { useState } from 'react';
import FormControl from './components/FormControl';
import useNominationForm from './utils/useNominationForm';
import { handleSubmit } from './utils';
import {
  Container,
  Form,
  Heading,
  Subhead,
  Button,
} from './styles/index.styled';
import Success from './components/Success';

const NominationForm = () => {
  const { datoCmsWebsiteForm } = useNominationForm();
  const [success, setSuccess] = useState(false);
  const [data, setData] = useState({
    firstname: '',
    email: '',
    nominatedname: '',
    nominatedcompany: '',
    nominatedreason: '',
  });
  const [validation, setValidation] = useState({
    firstname: '',
    email: '',
    nominatedname: '',
    nominatedcompany: '',
    nominatedreason: '',
  });

  const handleChange = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
    setValidation({
      ...validation,
      [e.target.name]: '',
    });
  };

  if (success) return <Success />;
  return (
    <Container>
      {datoCmsWebsiteForm?.heading && (
        <Heading>{datoCmsWebsiteForm?.heading}</Heading>
      )}
      {datoCmsWebsiteForm?.subhead && (
        <Subhead>{datoCmsWebsiteForm?.subhead}</Subhead>
      )}
      <Form
        id={datoCmsWebsiteForm.id}
        onSubmit={e =>
          handleSubmit(
            e,
            datoCmsWebsiteForm?.pardotFormHandler,
            data,
            setData,
            validation,
            setValidation,
            setSuccess
          )
        }
      >
        <FormControl
          type="text"
          name="firstname"
          label="Your name"
          required
          value={data.firstname}
          placeholder="What is your name?"
          handleChange={handleChange}
          errorMessage={validation.firstname}
          autoComplete="given-name"
        />
        <FormControl
          type="text"
          name="email"
          value={data.email}
          label="Your email"
          placeholder="What is your email?"
          required
          handleChange={handleChange}
          errorMessage={validation.email}
          autoComplete="email"
        />
        <FormControl
          type="text"
          name="nominatedname"
          value={data.nominatedname}
          label="First name of the nominee"
          placeholder="What is the first name of the nominee?"
          required
          handleChange={handleChange}
          errorMessage={validation.nominatedname}
          autoComplete="given-name"
        />
        <FormControl
          type="text"
          name="nominatedcompany"
          value={data.nominatedcompany}
          label="Name of company the nominee works for?"
          placeholder="What is the name of company the nominee works for?"
          required
          handleChange={handleChange}
          errorMessage={validation.nominatedcompany}
          autoComplete="given-name"
        />
        <FormControl
          type="textarea"
          name="nominatedreason"
          value={data.nominatedreason}
          label="Why are you nominating this person?"
          placeholder="Enter a description..."
          required
          handleChange={handleChange}
          errorMessage={validation.nominatedreason}
        />
        <Button type="submit" name="submit">
          {datoCmsWebsiteForm?.callToAction}
        </Button>
      </Form>
    </Container>
  );
};

export default NominationForm;
